import Layout from '@/layout'

export default [
	{
		order: 6,
		path: '/alarm-name-manage',
		component: Layout,
		meta: {
			title: '系统告警名称管理',
			subtitle: '告警',
			icon: 'icon-gaojing',
		},
		redirect: '/alarm-name-manage',
		children: [
			{
				path: '/alarm-name-manage',
				name: 'alarmNameManage',
				meta: {
					title: '系统告警名称管理',
					keepAlive: true,
					permissions: ['monitor:run:sys-alarm-name:list'],
				},
				component: () => import('@/pages/alarm-name-manage/index.vue'),
			},
		],
	},
]
